import React, { useEffect, useState } from "react";
import "rc-collapse/assets/index.css";
import Collapse, { Panel } from "rc-collapse";
import { Button, Col, Form, ListGroup, Row } from "react-bootstrap";
import Select from "react-select";
import {
  CriarClonagemEstabelecimentos,
  ListarCorredoresEstabelecimento,
  ListarEstabelecimentosSemPaginacao,
} from "../../providers/EstabelecimentoProvider";
import { toast } from "react-toastify";
import "./styles.css";

function ClonagemLoja() {
  const [estabelecimentos, setEstabelecimentos] = useState([]);
  const [estabelecimentosModeloOptions, setEstabelecimentosModeloOptions] = useState([]);
  const [estabelecimentosAlvoOptions, setEstabelecimentosAlvoOptions] = useState([]);
  const [estabelecimentoModelo, setEstabelecimentoModelo] = useState(null);
  const [estabelecimentoClone, setEstabelecimentoClone] = useState(null);
  const [corredoresEstabelecimentoModelo, setCorredoresEstabelecimentoModelo] = useState(
    [],
  );

  const [corredoresSelecionados, setCorredoresSelectionados] = useState({});

  useEffect(() => {
    (async () => {
      const select = "nome_fantasia estabelecimento_modelo";
      const docs = await ListarEstabelecimentosSemPaginacao(select);
      const mappedOptions = docs.map((d) => ({
        label: d.nome_fantasia,
        value: d._id,
        model: d.estabelecimento_modelo,
      }));
      setEstabelecimentos(docs);
      setEstabelecimentosModeloOptions(mappedOptions.filter((e) => e.model));
      setEstabelecimentosAlvoOptions(mappedOptions.filter((e) => !e.model));
    })();
  }, []);

  useEffect(() => {
    if (!estabelecimentoModelo) return;
    (async () => {
      const res = await ListarCorredoresEstabelecimento(estabelecimentoModelo.value);
      if (res && !res.length) {
        handleShowAlert(
          "Esse estabelecimento não possui corredores, selecione outro modelo",
          "error",
        );
        return setCorredoresEstabelecimentoModelo([]);
      }
      return setCorredoresEstabelecimentoModelo(res);
    })();
  }, [estabelecimentoModelo]);

  const handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else if (variant === "error") {
      toast.error(mensagem);
    } else {
      toast.info(mensagem);
    }
  };

  useEffect(() => {
    if (!estabelecimentoClone) return;
    (async () => {
      const res = await ListarCorredoresEstabelecimento(estabelecimentoClone.value);
      if (res && res.length) {
        handleShowAlert(
          "Cuidado, esse estabelecimento já possui corredores cadastrados",
          "error",
        );
        setEstabelecimentoClone(null);
      }
    })();
  }, [estabelecimentoClone]);

  const selecionarCorredor = (corredor) => {
    const idCorredor = corredor._id;
    const corredorHasSelected = corredoresSelecionados[idCorredor];
    if (corredorHasSelected) {
      setCorredoresSelectionados((prev) =>
        Object.keys(prev)
          .filter((k) => k !== idCorredor)
          .reduce((acc, k) => ({ ...acc, [k]: prev[k] }), {}),
      );
    } else {
      setCorredoresSelectionados((prev) => ({
        ...prev,
        [idCorredor]: {
          nome: corredor?.nome,
          categorias: {},
        },
      }));
    }
  };

  const selecionarCategoria = (corredor, categoria) => {
    const idCorredor = corredor._id;
    const idCategoria = categoria._id;
    const corredorSelecionado = corredoresSelecionados[idCorredor];
    if (!corredorSelecionado) {
      return handleShowAlert("Primeiro selecione o corredor", "error");
    }
    const categoriaHasSelected = corredorSelecionado.categorias[idCategoria];
    if (categoriaHasSelected) {
      setCorredoresSelectionados((prev) => ({
        ...prev,
        [idCorredor]: {
          ...corredorSelecionado,
          categorias: Object.keys(corredorSelecionado.categorias)
            .filter((k) => k !== idCategoria)
            .reduce((acc, k) => ({ ...acc, [k]: corredorSelecionado.categorias[k] }), {}),
        },
      }));
    } else {
      setCorredoresSelectionados((prev) => ({
        ...prev,
        [idCorredor]: {
          ...corredorSelecionado,
          categorias: {
            ...corredorSelecionado.categorias,
            [idCategoria]: {
              nome: categoria?.nome,
            },
          },
        },
      }));
    }
  };

  const alterarNovoPesoCategoria = (idCorredor, idCategoria, novoPeso) => {
    const corredor = corredoresSelecionados[idCorredor];
    if (!corredor) {
      return handleShowAlert("Primeiro selecione o corredor", "error");
    }
    const categoria = corredor.categorias[idCategoria];
    if (!categoria) {
      return handleShowAlert("Primeiro selecione a categoria", "error");
    }
    setCorredoresSelectionados((prev) => ({
      ...prev,
      [idCorredor]: {
        ...corredor,
        categorias: {
          ...corredor.categorias,
          [idCategoria]: {
            ...categoria,
            novoPeso,
          },
        },
      },
    }));
  };

  const iniciarClonagem = async () => {
    try {
      if (!estabelecimentoClone) {
        return handleShowAlert(
          "Por favor, selecione o estabelecimento a ser clonado",
          "error",
        );
      }
      const corredores = Object.keys(corredoresSelecionados).reduce(
        (acc, k) =>
          acc.concat({
            ...corredoresSelecionados[k],
            _id: k,
            categorias: Object.keys(corredoresSelecionados[k].categorias).reduce(
              (acc, j) =>
                acc.concat({
                  ...corredoresSelecionados[k].categorias[j],
                  _id: j,
                }),
              [],
            ),
          }),
        [],
      );
      if (corredores.find((c) => !c.categorias || !c.categorias.length)) {
        return handleShowAlert(
          "Existem corredores sem categoria selecionadas, por favor selecione as categorias",
          "error",
        );
      }
      await CriarClonagemEstabelecimentos({
        idEstabelecimentoModelo: estabelecimentoModelo.value,
        idEstabelecimentoClone: estabelecimentoClone.value,
        corredores: corredores,
      });
      handleShowAlert("Clonagem realizada com sucesso!", "success");
      setEstabelecimentoClone(null);
      setEstabelecimentoModelo(null);
      setCorredoresEstabelecimentoModelo([]);
      setCorredoresSelectionados({});
    } catch (error) {
      handleShowAlert("Falha na clonagem das lojas!", "error");
    }
  };

  return (
    <div style={{ margin: 10, marginLeft: 50, marginRight: 50 }}>
      <br></br>
      <Row>
        <Col md={9}>
          <h3>Clonagem de Lojas</h3>
        </Col>
      </Row>
      <br></br>
      <br></br>
      <Row>
        <Col md={6}>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Selecione o Estabelecimento Modelo</Form.Label>
                <Select
                  isDisabled={!estabelecimentosModeloOptions}
                  value={estabelecimentoModelo}
                  isClearable
                  isSearchable
                  onChange={(opt) => {
                    setEstabelecimentoModelo(opt);
                  }}
                  options={estabelecimentosModeloOptions}
                  placeholder="Estabelecimento Modelo"
                />
                <Form.Text>
                  Estabelecimento que servirá como modelo para clonagem
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Selecione o Estabelecimento Alvo</Form.Label>
                <Select
                  isDisabled={!estabelecimentosAlvoOptions}
                  value={estabelecimentoClone}
                  isClearable
                  isSearchable
                  onChange={(opt) => {
                    setEstabelecimentoClone(opt);
                  }}
                  options={estabelecimentosAlvoOptions}
                  placeholder="Estabelecimento Modelo"
                />
                <Form.Text>Estabelecimento a ser clonado</Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <h5>
                Nova estrutura da loja a ser clonada ({estabelecimentoClone?.label})
              </h5>
              <ul>
                {Object.keys(corredoresSelecionados).map((k) => (
                  <li>
                    <b>{corredoresSelecionados[k].nome}</b>
                    <ul>
                      {Object.keys(corredoresSelecionados[k].categorias).map((j) => (
                        <li>
                          <b>{corredoresSelecionados[k].categorias[j].nome}</b>
                          {"\t"}
                          (novo peso em KG:{" "}
                          {corredoresSelecionados[k].categorias[j].novoPeso ||
                            "Não mudará"}
                          )
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Button
                variant="primary"
                disabled={!Object.keys(corredoresSelecionados).length}
                onClick={() => iniciarClonagem()}
              >
                Iniciar clonagem
              </Button>
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <h5>
            Selecione os Corredores e Categorias que serão Clonados (
            {estabelecimentoModelo?.label})
          </h5>
          <Collapse accordion={true}>
            {corredoresEstabelecimentoModelo.map((corredor, i) => {
              return (
                <Panel
                  key={i}
                  header={
                    <Row style={{ flex: 1 }}>
                      <Col>
                        <h5 style={{ marginTop: 10 }}>
                          {corredor.nome}
                          <span
                            style={{
                              marginLeft: 8,
                              fontSize: 14,
                              fontWeight: "normal",
                            }}
                          >
                            ({corredor.categorias.length}) categorias
                          </span>
                        </h5>
                      </Col>
                      <Col style={{ marginTop: 10 }}>
                        <Form.Check
                          type="checkbox"
                          checked={!!corredoresSelecionados[corredor._id]}
                          label="Selecionar Corredor"
                          onChange={(e) => selecionarCorredor(corredor)}
                        />
                      </Col>
                    </Row>
                  }
                >
                  {corredor.categorias.map((categoria, j) => {
                    return (
                      <ListGroup.Item key={j}>
                        <Row style={{ flex: 1 }}>
                          <Col style={{ marginTop: 10 }}>
                            <Row>
                              <Col>
                                <p style={{ fontWeight: "bold" }}>{categoria.nome}</p>
                              </Col>
                              <Col>
                                <Form.Check
                                  type="checkbox"
                                  label="Selecionar Categoria"
                                  checked={
                                    !!corredoresSelecionados[corredor._id]?.categorias[
                                      categoria._id
                                    ]
                                  }
                                  onClick={(e) =>
                                    selecionarCategoria(corredor, categoria)
                                  }
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <Form.Group>
                                  <Form.Label>
                                    Novo peso para os produtos da categoria
                                  </Form.Label>
                                  <Form.Control
                                    value={
                                      corredoresSelecionados[corredor._id]?.categorias[
                                        categoria._id
                                      ]?.novoPeso || ""
                                    }
                                    type="number"
                                    min={0}
                                    placeholder="Novo peso (KG)"
                                    onChange={(e) =>
                                      alterarNovoPesoCategoria(
                                        corredor._id,
                                        categoria._id,
                                        e.target.value,
                                      )
                                    }
                                  />
                                  <Form.Text>
                                    Todos os produtos dessa categoria terão o peso
                                    alterado para o informado
                                  </Form.Text>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </ListGroup.Item>
                    );
                  })}
                </Panel>
              );
            })}
          </Collapse>
        </Col>
      </Row>
      <br></br>

      <Row></Row>
    </div>
  );
}

export default ClonagemLoja;
